import xss, { safeAttrValue as XssSafeAttrValue, escapeAttrValue, friendlyAttrValue, } from 'xss';
const commonGlobalAttrs = ['style', 'dir', 'class'];
const isPlaceholderUrl = (url) => url.startsWith('${') && url.indexOf('}') !== -1;
function safeAttrValue(tag, name, value, cssFilter) {
    if (name === 'href' || name === 'src') {
        const friendlyValue = friendlyAttrValue(value);
        if (isPlaceholderUrl(friendlyValue)) {
            return escapeAttrValue(friendlyValue);
        }
        return XssSafeAttrValue(tag, name, value.replace(/^HTTPS/i, 'https'), cssFilter);
    }
    return XssSafeAttrValue(tag, name, value, cssFilter);
}
const validators = [
    (url) => url.startsWith('//'),
    (url) => url.startsWith('http://'),
    (url) => url.startsWith('https://'),
    (url) => url.startsWith('tel:'),
    (url) => url.startsWith('mailto:'),
    (url) => url.startsWith('#'),
    isPlaceholderUrl,
];
const isSupportedUrl = (url) => {
    let isSupported = false;
    const lowercaseUrl = url.toLowerCase();
    for (const validator of validators) {
        if (validator(lowercaseUrl)) {
            isSupported = true;
            break;
        }
    }
    return isSupported;
};
const LEAVE_ELEMENT = undefined;
const REMOVE_ELEMENT = '';
export const getCleanUserHtmlWithMetadata = (html) => {
    const removedTags = {};
    const removedAttributes = {};
    const removedInvalidAttrValues = {};
    const onIgnoreTag = (tag) => {
        removedTags[tag] = tag;
        return REMOVE_ELEMENT;
    };
    const onTagAttr = (tag, attr, value) => {
        if (tag === 'a' && attr === 'href') {
            if (!isSupportedUrl(value)) {
                const tagAttrPair = `${tag},${attr}`;
                if (!removedInvalidAttrValues[tagAttrPair]) {
                    removedInvalidAttrValues[tagAttrPair] = [];
                }
                removedInvalidAttrValues[tagAttrPair].push(value);
                return REMOVE_ELEMENT;
            }
        }
        return LEAVE_ELEMENT;
    };
    const onIgnoreTagAttr = (tag, attr) => {
        const tagAttrPair = `${tag},${attr}`;
        removedAttributes[tagAttrPair] = tagAttrPair;
        return REMOVE_ELEMENT;
    };
    const cleanHtml = xss(html, {
        whiteList: {
            h1: commonGlobalAttrs,
            h2: commonGlobalAttrs,
            h3: commonGlobalAttrs,
            h4: commonGlobalAttrs,
            h5: commonGlobalAttrs,
            div: commonGlobalAttrs,
            span: commonGlobalAttrs,
            p: commonGlobalAttrs,
            a: ['style', 'dir', 'target', 'rel', 'href'],
            ol: ['style', 'dir', 'class', 'start'],
            ul: commonGlobalAttrs,
            li: commonGlobalAttrs,
            s: commonGlobalAttrs,
            b: commonGlobalAttrs,
            i: commonGlobalAttrs,
            u: commonGlobalAttrs,
            bdi: ['style', 'dir'],
            br: [],
            pre: commonGlobalAttrs,
            table: [
                'style',
                'class',
                'align',
                'role',
                'cellpadding',
                'cellspacing',
                'width',
                'border',
            ],
            tr: ['style', 'class'],
            td: ['style', 'class', 'align', 'valign', 'width', 'colspan', 'rowspan'],
            tbody: ['style', 'class'],
            thead: ['style', 'class'],
            img: [
                'style',
                'class',
                'src',
                'width',
                'height',
                'border',
                'alt',
                'usemap',
                'dir',
                'target',
                'rel',
            ],
        },
        onIgnoreTag,
        onTagAttr,
        onIgnoreTagAttr,
        safeAttrValue,
        css: false,
    });
    return {
        html: cleanHtml,
        meta: {
            removedTags: Object.values(removedTags),
            removedAttributes: Object.values(removedAttributes),
            removedInvalidAttrValues,
        },
    };
};
//# sourceMappingURL=cleanUserHtml.js.map